/* Product card colour swatches:
   - hover/focus a swatch -> preview that variant's image
   - leave the swatch     -> revert to the selected image (or the original)
   - click a swatch        -> select it; "Shop now" points to that variant
   Images are swapped only once fully loaded, so a slow image never flashes the
   wrong picture; the current image stays until the new one is ready. */
(function () {
  function initCard(card) {
    if (card.dataset.swInit) return;
    var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-swatch]'));
    if (!swatches.length) return;
    card.dataset.swInit = '1';

    var main = card.querySelector('.card__media img');
    var cta = card.querySelector('[data-cta]');
    if (!main) return;

    var origSrc = main.getAttribute('src') || '';
    var origSrcset = main.getAttribute('srcset') || '';
    var selectedSrc = null;
    var pending = null;

    function show(src, srcset) {
      if (!src) return;
      pending = src;
      function apply() {
        if (pending !== src) return; // a newer hover/selection won
        if (srcset) { main.setAttribute('srcset', srcset); } else { main.removeAttribute('srcset'); }
        main.src = src;
      }
      var probe = new Image();
      probe.onload = apply;
      probe.onerror = apply;
      probe.src = src;
      if (probe.complete) apply();
    }

    function revert() {
      if (selectedSrc) { show(selectedSrc, null); } else { show(origSrc, origSrcset); }
    }

    swatches.forEach(function (sw) {
      var img = sw.getAttribute('data-swatch-img');
      var url = sw.getAttribute('data-variant-url');

      sw.addEventListener('mouseenter', function () { show(img, null); });
      sw.addEventListener('focus', function () { show(img, null); });

      sw.addEventListener('click', function (e) {
        e.preventDefault();
        swatches.forEach(function (s) { s.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        if (img) { selectedSrc = img; show(img, null); }
        if (cta && url) cta.setAttribute('href', url);
      });
    });

    // Revert only when the pointer/focus leaves the whole card, so moving
    // between swatches never flashes back to the default image.
    card.addEventListener('mouseleave', revert);
    card.addEventListener('focusout', function (e) {
      if (!card.contains(e.relatedTarget)) revert();
    });

    // Warm the cache on card hover so swaps are instant.
    var preloaded = false;
    card.addEventListener('mouseenter', function () {
      if (preloaded) return;
      preloaded = true;
      swatches.forEach(function (sw) {
        var im = sw.getAttribute('data-swatch-img');
        if (im) { var p = new Image(); p.src = im; }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
